import * as lazyIndex from './lazyIndex';
import { ComponentClass } from 'react';
import { createLazyComponent, LazyModule } from 'owa-bundling';
export { IconDataType, AnchorProps } from './components/EmbeddedMessage';
export { IconInfo, CustomClassNames } from './components/EmbeddedMessageWrapper';
export { ComponentClass };

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(
        /* webpackChunkName: "EmbeddedMessage", webpackPreload: true */ './lazyIndex'
    )
);

export const LazyEmbeddedMessageWrapper = createLazyComponent(
    lazyModule,
    m => m.EmbeddedMessageWrapper
);
